module.exports = __webpack_public_path__ + "img/16581281_L.7369c243.png";